"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Abstract class that defines common interface and functionality between tab activator modes
 */
var BaseTabActivator = /** @class */ (function () {
    function BaseTabActivator(tabsWidget) {
        this.tabsWidget = tabsWidget;
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    BaseTabActivator.prototype.tabIndexFromKeyDown = function (tabIndex, keyValue) {
        var numTabs = this.tabsWidget.props.tabs.length;
        switch (keyValue) {
            // With the arrow keys, we wrap around. For example, if the last tab is focused or active and the
            // user keys down on the right arrow, we wrap around so that now the first tab is focused or active.
            case 'ArrowRight':
                return (tabIndex + 1) % numTabs;
            case 'ArrowLeft':
                return (numTabs + tabIndex - 1) % numTabs;
            case 'Home':
                return 0;
            case 'End':
                return numTabs - 1;
            default:
                return -1;
        }
    };
    BaseTabActivator.preventDefaultAndStopPropagation = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    return BaseTabActivator;
}());
exports.BaseTabActivator = BaseTabActivator;
//# sourceMappingURL=BaseTabActivator.js.map